const autobind = (object, self) => {
  const functions = Object.getOwnPropertyNames(object.prototype).filter(f => f.includes('handle'));
  functions.forEach(f => {
    // eslint-disable-next-line no-param-reassign
    self[f] = self[f].bind(self);
  });
};

export default autobind
